import { render, staticRenderFns } from "./AddPreparation.vue?vue&type=template&id=6be15dca&scoped=true"
import script from "./AddPreparation.vue?vue&type=script&lang=js"
export * from "./AddPreparation.vue?vue&type=script&lang=js"
import style0 from "./AddPreparation.vue?vue&type=style&index=0&id=6be15dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be15dca",
  null
  
)

export default component.exports